import {ModelTestFieldsSchema, TierCountsSchema} from '../../scoring';
import {ObjectIdSchema} from '../../zod';
import {ApiDefinition, WithIdSchema} from '../definitions';
import {z} from 'zod';
import {GetModelTestResultsResponseSchema} from '../responses';
import {ModelTestDefinitionSchema} from '../../modelTest';
import {TestListSchema} from '../../testLists';

export const MaxModelTestLists = 10;

export const GetModelTestFields = {
  path: 'modelTestFields',
  method: 'get',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
  }),
  responseDataSchema: ModelTestFieldsSchema,
} satisfies ApiDefinition;

export const GetModelTestResults = {
  path: 'modelTestResults',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
  }),
  responseDataSchema: GetModelTestResultsResponseSchema,
} satisfies ApiDefinition;

export const GetModelTestListResults = {
  path: 'modelTestListResults',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
    listId: ObjectIdSchema,
  }),
  responseDataSchema: TierCountsSchema,
} satisfies ApiDefinition;

export const GetModelTestDefinition = {
  path: 'modelTestDefinition',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
  }),
  responseDataSchema: ModelTestDefinitionSchema.extend({
    lists: z.array(TestListSchema.and(z.object(WithIdSchema))),
  }).nullable(),
} satisfies ApiDefinition;

export const CreateModelTestControlList = {
  path: 'createModelTestControlList',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const RefreshModelTestControlList = {
  path: 'refreshModelTestControlList',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
    listId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const DeleteModelTestList = {
  path: 'deleteModelTestList',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
    listId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;

export const UpdateModelTestLists = {
  path: 'updateModelTestLists',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    marketId: ObjectIdSchema,
    listIds: ObjectIdSchema.array(),
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
